import { useQuery } from '@tanstack/react-query';

import { tutorialService, type TutorialListaFiltros } from '@/services/tutorialService';
import { getRefreshConfig } from '@/config/refresh.config';

// Só leitura. As mutações (criar/atualizar/excluir/publicar) saíram junto com o
// admin: o tutorial é a projeção de um artigo da base de conhecimento e quem
// edita é o CRM. O BFF sequer expõe caminho de escrita.

export type TutorialFilters = TutorialListaFiltros;

export const useTutorials = (filtros: TutorialFilters = {}) =>
  useQuery({
    queryKey: ['tutoriais', filtros],
    queryFn: () => tutorialService.list(filtros),
    staleTime: 5 * 60 * 1000,
    ...getRefreshConfig('moderate'),
  });

/**
 * Busca por SLUG. A versão anterior aceitava slug ou id e adivinhava pelo
 * formato — o que quebrava em slug numérico. O endereço público é o slug;
 * id é detalhe interno e não aparece em URL.
 */
export const useTutorial = (slug: string | undefined) =>
  useQuery({
    queryKey: ['tutorial', slug],
    queryFn: () => tutorialService.getBySlug(String(slug)),
    enabled: Boolean(slug),
    staleTime: 5 * 60 * 1000,
  });

export const useSearchTutorials = (q: string, filtros: TutorialFilters = {}) =>
  useQuery({
    queryKey: ['tutoriais', 'busca', q, filtros],
    queryFn: () => tutorialService.search(q, filtros),
    // Sem termo não há o que buscar — evita disparar a listagem inteira a cada
    // tecla apagada.
    enabled: q.trim().length > 1,
    staleTime: 60 * 1000,
  });
